import { render, staticRenderFns } from "./ContentLoaderPaymentMobile.vue?vue&type=template&id=1519a905&"
import script from "./ContentLoaderPaymentMobile.vue?vue&type=script&lang=js&"
export * from "./ContentLoaderPaymentMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports